const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBProgressDisputed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-progress-disputed",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconB-progress-disputed1",
    serifid: "iconB-progress-disputed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1c6.071,0 11,4.929 11,11c0,6.071 -4.929,11 -11,11c-6.071,0 -11,-4.929 -11,-11c0,-6.071 4.929,-11 11,-11Zm0,1.986c-4.975,0 -9.014,4.039 -9.014,9.014c0,4.975 4.039,9.014 9.014,9.014c4.975,-0 9.014,-4.039 9.014,-9.014c-0,-4.975 -4.039,-9.014 -9.014,-9.014Zm1.103,9.522c0,0.611 -0.495,1.107 -1.106,1.107c-0.61,-0 -1.106,-0.496 -1.106,-1.107l0,-4.871c0,-0.61 0.496,-1.106 1.106,-1.106c0.611,-0 1.106,0.496 1.106,1.106l0,4.871Zm-1.1,2.749c0.61,-0 1.106,0.496 1.106,1.106c-0,0.61 -0.496,1.106 -1.106,1.106c-0.611,0 -1.106,-0.496 -1.106,-1.106c-0,-0.61 0.495,-1.106 1.106,-1.106Z",
    style: {
      fill: "#d30000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBProgressDisputed);
export default __webpack_public_path__ + "static/media/iconB-progress-disputed.535dbd57ad34f85f26ebf67d12a2f40a.svg";
export { ForwardRef as ReactComponent };